import React, { useState } from 'react'
import { NavLink, useLocation, useNavigate } from 'react-router-dom'
import { Formik, Field, Form } from 'formik'
import * as Yup from 'yup'

import Input from '../../../components/common/CustomInput'
import axiosAuthInstance from '../../../utils/axios/axiosAuthInstance'

// Custom hook to get query parameters
const useQueryParams = () => {
  const location = useLocation()
  return new URLSearchParams(location.search)
}

// Validation Schema
const validationSchema = Yup.object({
  password: Yup.string()
    .min(6, 'Password must be at least 6 characters')
    .required('Password is required'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password')], 'Passwords must match')
    .required('Confirm Password is required'),
})

const ResetPassword = () => {
  const navigate = useNavigate()
  const queryParams = useQueryParams()
  const token = queryParams.get('code')
  const email = queryParams.get('email')

  const [error, setError] = useState('')

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      await axiosAuthInstance.post('/reset-password', values)
      navigate('/login') // Redirect after success
    } catch (err) {
      const errorMessage =
        err.response?.data?.message || 'An unexpected error occurred.'
      setError(errorMessage)
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className='flex min-h-screen flex-col justify-center px-6 py-12'>
      <div className='sm:mx-auto sm:w-full sm:max-w-sm'>
        <h2 className='text-center text-2xl font-bold'>Reset Password</h2>
      </div>

      <div className='sm:mx-auto sm:w-full sm:max-w-sm mt-10'>
        <Formik
          initialValues={{ password: '', confirmPassword: '', token, email }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <Form className='flex flex-col gap-6'>
              <Field
                name='password'
                type='password'
                label='Password'
                placeholder='Enter password'
                component={Input}
              />
              <Field
                name='confirmPassword'
                type='password'
                label='Confirm Password'
                placeholder='Confirm password'
                component={Input}
              />

              {error && <p className='text-red-600 text-sm'>{error}</p>}

              <button
                type='submit'
                disabled={isSubmitting}
                className={`w-full text-lg font-semibold text-white bg-prime shadow px-4 py-3 mt-4 rounded-md ${
                  isSubmitting ? 'opacity-50 cursor-not-allowed' : ''
                }`}
              >
                {isSubmitting ? 'Submitting...' : 'Submit'}
              </button>

              <div className='text-sm mt-5 flex gap-1'>
                <p>Already have an account?</p>
                <NavLink
                  to='/login'
                  className='font-semibold text-[#EF4044] hover:text-[#EF4044]'
                >
                  Login
                </NavLink>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  )
}

export default ResetPassword
